export const moreActionsLabel = (recordName?: string): string =>
  recordName ? `More actions for ${recordName}` : 'More actions';
